import GenericRequest, { METHOD_PUT } from '../../../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../../../shared/webservices/endpoint';

export class ContractorFileCreateTask extends GenericRequest {

    _request; // ContractorFileCreateRequest

    constructor(request) {
        super(METHOD_PUT, ApiEndpoints.CONTRACTOR_FILES_ADD);
        this._request = request;
    }

    overrideRequest() {
        return this._request.body();
    }
}



// WEBPACK FOOTER //
// ./src/app/documentary-library/form/create/webservices/ContractorFileCreateTask.js